import { isPresent } from '@jjvgaming/player-payback-library'

export const allPaths = [
  '/',
  '/CreateAccount',
  '/Home',
  '/Development/Home',
  '/Compliance',
  '/ContactUs',
  '/PatronCheckIns',
  '/Locations',
  '/FlexPay',
  '/InfoCenter/Newsletters',
  '/InfoCenter/News',
  '/InfoCenter/Resources',
  '/GamingReports',
  '/GamingReports/GamingReportsPage',
  '/GamingReports/CreditsWageredByMachine',
  '/GamingReports/WeeklySnapshot',
  '/GamingReports/WeeklySnapshotLocationSelect',
  '/GamingReports/PerformanceTrends',
  '/GamingReports/PerformanceTrendsTablePage',
  '/GamingReports/CreditsWageredByMachine',
  '/GamingReports/CreditsWageredByHour',
  '/GamingReports/VgtSnapshot',
  '/GamingReports/VgtTrends',
  '/GamingReports/CreditsWageredHourlyTrends',
  '/GamingReports/TrailingNtiTrends',
  '/PlayerPaybackReports/PatronActivity',
  '/PlayerPaybackReports/PatronStats',
  '/PlayerPaybackReports/PatronList',
  '/PlayerPaybackReports/PatronRewardRedemptions',
  '/PlayerPayback',
  '/Rewards',
  '/Specials&Events',
  '/Specials&Events/:id',
  '/Sweepstakes',
  '/Sweepstakes/:id/Overview',
  '/Sweepstakes/:id/Winners',
  '/Sweepstakes/:id/ParticipatingLocations',
  '/Sweepstakes/:id/EnrollLocations',
  '/Sweepstakes/:id/AdditionalEnrollmentDetails',
  '/Sweepstakes/:id/ReviewLocationsToEnroll',
  '/LocationSweepstakes',
  '/LocationSweepstakes/:id/Overview',
  '/LocationSweepstakes/:id/Winners',
  '/LocationSweepstakes/:id/ParticipatingLocations',
  '/LocationSweepstakes/:id/Settings',
  '/LicensedEstablishments/:id',
  '/LicensedEstablishmentUsers',
  '/LicensedEstablishmentUsers/NewLEConnectUserPage',
  '/LicensedEstablishmentUsers/LEConnectUserDetailsPage/:id',
  // '/LiveAtLocation',
  // '/LiveAtLocation/PatronDetails/:id/LicensedEstablishment/:licensedEstablishmentId',
  // '/LiveAtLocation/PatronDetails/:id',
  '/RewardsProgram/:id',
  // '/RewardsProgram/:id/Settings',
  '/RewardsProgram/:id/Redemption',
  '/RewardsProgram/:id/ActivityLog',
  '/RewardsProgram/:id/RewardsCatalog/:rewardCatalogId',
  '/LocationBadges',
  '/LocationBadges/:id',
] as const

const allPathsAsRegExps = allPaths.map(
  (path) => new RegExp('^' + path.replace(/:\w*id/gi, String.raw`\d+`) + '$')
)

export const findPath = (path: string) => {
  const foundPath = allPathsAsRegExps.find((x) => x.test(path))
  if (!foundPath) {
    return null
  }
  return foundPath
}

export type Path = (typeof allPaths)[number]
export const isPath = (maybePath: string): maybePath is Path =>
  isPresent(findPath(maybePath))
